export default __webpack_public_path__ + "static/media/Cousins Packaging.3a6aa3a7.png";